import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    wrapper: css({
        display: 'flex',
        flexDirection: 'row',
        fontSize: '21px',
        fontStyle: 'normal',
        fontWeight: '700',
        lineHeight: '100%',
        textTransform: 'uppercase',
        [theme.breakpoints.down('lg')]: {
            flexDirection: 'column',
            gap: '15px',
            justifyContent: 'space-between',
        },
    }),

    active: css({
        color: theme.palette.common.black,
        marginRight: '20px',
        [theme.breakpoints.down('lg')]: {
            marginRight: '0px',
        },
    }),

    disabled: css({
        color: theme.palette.text.disabled,
        marginRight: '20px',
        [theme.breakpoints.down('lg')]: {
            marginRight: '0px',
        },
    }),

    stepIcon: css({
        width: '28px',
        height: '28px',
        border: `1px solid ${theme.palette.text.disabled}`,
        color: theme.palette.text.disabled,
        borderRadius: '50px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        ...(isHosTheme && {
            h4: {
                blockSize: '14px',
            },
        }),
    }),

    stepLabelText: css({
        ...(isHosTheme && {
            [theme.breakpoints.down('lg')]: {
                fontSize: '14px',
                fontWeight: 500,
            },
            fontSize: '21px',
        }),
    }),

    stepIconActive: css({
        border: `1px solid ${theme.palette.text.primary}`,
        color: theme.palette.text.primary,
    }),

    stepConnector: css({
        '.step-connector-line': {
            flex: '1 1 auto',
            position: 'absolute',
            top: '13px',
            left: 'calc(-50% + 14px)',
            right: 'calc(50% + 14px)',
            height: '1px',
            background: theme.palette.text.disabled,
        },
    }),

    stepConnectorActive: css({
        '.step-connector-line': {
            background: theme.palette.text.primary,
        },
    }),
};
